<script setup lang="ts">
import { RouterView } from 'vue-router'
import Toast from 'primevue/toast'
import ErrorBoundary from '@uiKit/components/ErrorBoundary.vue'
</script>

<template>
  <ErrorBoundary>
    <RouterView />
    <Toast position="top-right" />
  </ErrorBoundary>
</template>
